export const api_forfreight_url = process.env.REACT_APP_API1_BASE_URL;
export const we_forfreight_url = process.env.REACT_APP_API2_BASE_URL;
export const auth_url = process.env.REACT_APP_API3_BASE_URL;
export const spanish_nodeRed = process.env.REACT_APP_API_SPANISH;
export const greek_nodeRed = process.env.REACT_APP_API_GREEK;
export const romanian_nodeRed = process.env.REACT_APP_API_ROMANIAN;